import { History } from "history";
import * as React from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../store/rootReducer";
import { Dispatch } from "redux";

import { Wrap } from "./styles";

// import i18next from 'i18next';
import { withTranslation, WithTranslation } from "react-i18next";
import Confirm from "../../components/Confirm";
import { goToPage } from "../../../utils/tools";

type Props = {
  history: History;
  email?: string;
  subscriptionSucces: boolean | null;
  logged: boolean;
} & WithTranslation;
type State = {};

class ConfirmByMyzToken extends React.Component<Props, State> {
  public readonly state: State = {};

  componentDidMount() {
    const { subscriptionSucces, history } = this.props;
    if (!subscriptionSucces) {
      goToPage("/home", history);
    }
  }

  render(): JSX.Element {
    const { email, logged } = this.props;
    return (
      <Wrap>
        <Confirm email={email} logged={logged} />
      </Wrap>
    );
  }
}

function mapStateToProps(state: GlobalState) {
  const email = state.subscriptionemail.email;
  const subscriptionSucces = state.wotdformdata.loaded;
  return {
    logged: !!state.myztokenuser.data?.userId,
    email,
    subscriptionSucces,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(ConfirmByMyzToken));
